import { Dialog, DialogContent } from '@superfunnel/ui-core/v2/Dialog';

import HtmlStepperEditor from '@/components/HtmlStepperEditor/HtmlStepperEditor';

interface HtmlStepperEditorModalProps {
  quizId: string;
  initialFormId: string;
  open?: boolean;
  onClose?: () => void;
}

export default function HtmlStepperEditorModal({
  quizId,
  initialFormId,
  open,
  onClose,
}: HtmlStepperEditorModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="h-screen w-screen max-w-none rounded-none bg-gray-50 p-0"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {open && (
          <HtmlStepperEditor
            quizId={quizId}
            initialFormId={initialFormId}
            onClose={() => onClose?.()}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
